import React, { FC } from 'react'
import Button from 'transfix-ui/components/Button'
import LogoTransfix from 'transfix-ui/components/LogoTransfix'
import { Link } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { brandColors } from 'transfix-ui/theme/colors'
import { WarningIcon } from 'transfix-icons'
import { useTextStyles } from './DriverValidationPage'

// For all errors other than unauthorized
export const DriverValidationErrorDisplay: FC = () => {
  const classes = useTextStyles()
  const reloadPage = () => window.location.reload()

  return (
    <Box display='flex' flexDirection='column' alignItems='center' marginX='16px'>
      <Box marginTop='32px' marginBottom='112px'>
        <LogoTransfix width={130} />
      </Box>
      <Box
        width='80px'
        height='80px'
        bgcolor={brandColors.coolGray1}
        borderRadius='20px'
        marginBottom='16px'
        padding='16px'>
        <WarningIcon size='xxlarge' color='coolGray5' />
      </Box>
      <Box marginBottom='16px'>
        <Typography variant='subtitle1' className={classes.subtitleOne} align='center'>
          We couldn’t load this page
        </Typography>
        <Box height='4px' />
        <Typography variant='body2' className={classes.bodyTwo} align='center'>
          There was an error loading this page. Retry or{' '}
          <Link href='tel:6469484480'>
            <b>call us</b>
          </Link>{' '}
          if the problem persists.
        </Typography>
      </Box>
      <Button color='secondary' fullWidth onClick={reloadPage}>
        Retry
      </Button>
    </Box>
  )
}
